import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import Swal from 'sweetalert2';

import { SpinnerService } from '../../shared/components/spinner/spinner.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(
    private http: HttpClient,
    private spinnerService: SpinnerService
  ) {}

  public get<T>(endPoint, params) {
    return this.http
      .get<T>(environment.apiUrl + endPoint, {
        params
      })
      .pipe(catchError(this.handleError));
  }

  public post<t>(endPoint, param) {
    return this.http
      .post<t>(environment.apiUrl + endPoint, param)
      .pipe(catchError(this.handleError));
  }

  public getExternalApi<T>(endPoint, params) {
    return this.http
      .get<T>(endPoint, {
        params
      })
      .pipe(catchError(this.handleError));
  }

  public put<t>(endPoint, param) {
    return this.http
      .put<t>(environment.apiUrl + endPoint, param)
      .pipe(catchError(this.handleError));
  }

  public patch<t>(endPoint, param) {
    return this.http
      .patch<t>(environment.apiUrl + endPoint, param)
      .pipe(catchError(this.handleError));
  }

  public delete<t>(endPoint, param) {
    return this.http
      .delete<t>(environment.apiUrl + endPoint, param)
      .pipe(catchError(this.handleError));
  }

  public deleteWithBody<T>(endPoint, params?) {
    return this.http
      .request<T>('delete', environment.apiUrl + endPoint, {
        body: params
      })
      .pipe(catchError(this.handleError));
  }

  // Error handling
  private handleError(errorResponse: HttpErrorResponse) {
    let errorMessage = '';
    if (errorResponse.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = errorResponse.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${errorResponse.status}\nMessage: ${errorResponse.message}`;
    }
    if (errorResponse && errorResponse.status === 0) {
      console.log('Error tracking when system is down: ', errorResponse);
      // For errors without status
      Swal.fire({
        title: 'Oops...',
        html: `<h3 class="m-0">Unknown Error</h3>
        <p class="m-0 bold">Something Went Wrong</p>`,
        icon: 'error'
      });
    } else if (errorResponse && errorResponse.status < 500) {
      // Mostly for bad request errors
      Swal.fire({
        title: 'Oops...',
        html: `<h3 class="m-0">Error Code ${errorResponse.status}</h3>
        <p class="m-0 bold">${errorResponse.error.error}</p>
        <small class="m-0">(Details: ${errorResponse.error.message})</small>`,
        icon: 'error'
      });
    } else {
      console.log('Error tracking when system is down: ', errorResponse);
      // For status 500 errors
      Swal.fire({
        title: 'Oops...',
        html: `<h3 class="m-0">Error Code ${errorResponse.status}</h3>
        <p class="m-0 bold">Something went wrong</p>`,
        icon: 'error'
      });
    }
    return throwError(errorMessage);
  }
}
